"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfAllTickArraysInitialized = void 0;
const __1 = require("../..");
function checkIfAllTickArraysInitialized(tickArrays) {
    // Check if all the tick arrays have been initialized.
    const uninitializedIndices = __1.TickArrayUtil.getUninitializedArrays(tickArrays.map((array) => array.data));
    if (uninitializedIndices.length > 0) {
        const uninitializedArrays = uninitializedIndices
            .map((index) => tickArrays[index].address.toBase58())
            .join(", ");
        throw new Error(`TickArray addresses - [${uninitializedArrays}] need to be initialized.`);
    }
}
exports.checkIfAllTickArraysInitialized = checkIfAllTickArraysInitialized;
